import React from "react";

import { observer } from "mobx-react";
import Link from "next/link";
import { lighten, readableColor } from "polished";
import PropTypes from "prop-types";
import styled from "styled-components";

export const StyledJobBox = styled.a`
  min-height: 100px;
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme }) =>
    readableColor(
      theme.primaryBackgroundColor,
      theme.textColor,
      theme.negativeTextColor,
      false
    )};
  background-color: ${({ theme }) => theme.primaryBackgroundColor};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) =>
      lighten(0.1, `${theme.primaryBackgroundColor}`)};
    color: ${({ theme }) =>
      readableColor(
        theme.primaryBackgroundColor,
        theme.textColor,
        theme.negativeTextColor,
        false
      )};
  }
`;

function SimpleJobCard(props) {
  const { vacancy } = props;

  return (
    <Link href={`/job/${vacancy.id}`} passHref legacyBehavior>
      <StyledJobBox className="text-center py-4 px-2 d-flex flex-column h-100">
        <p className="fs-4 mb-2">{vacancy.jobTitle}</p>
        <div className="mt-auto">
          {vacancy?.location && (
            <p className="m-0 text-truncate">{vacancy.location?.city}</p>
          )}
          {vacancy?.remuneration && (
            <p className="m-0">{vacancy.remuneration?.description}</p>
          )}
        </div>
      </StyledJobBox>
    </Link>
  );
}

export default observer(SimpleJobCard);

SimpleJobCard.propTypes = {
  vacancy: PropTypes.shape({
    category: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    jobTitle: PropTypes.string,
    location: PropTypes.objectOf(),
    remuneration: PropTypes.objectOf(),
  }),
};

SimpleJobCard.defaultProps = {
  vacancy: {},
};
